import {
  GET_GOLF_COURSES,
  GET_GOLF_COURSES_SUCCESS,
  GET_GOLF_COURSES_ERROR,
} from "./../../actionType.js";

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AllGolfCourses = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOLF_COURSES:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_COURSES_SUCCESS:
      state = {
        ...state,
        data: action.payload?.data?.results,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_COURSES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AllGolfCourses;
